<div class="projection-grid-container">
  <div class="grid-scroll-wrapper">
    <table class="projection-table">
      <thead>
        <tr>
          <th class="label-header-cell sticky-col"></th>

          <th *ngFor="let scenario of scenarios"
              appProjectionScenarioHeader
              [scenario]="scenario"
              [scenarioYear]="getScenarioYear(scenario)"
              [baselineDelta]="getBaselineDelta(scenario)"
              class="scenario-header-cell"
              [ngClass]="{
                'prev-return-header': scenario.type === 'previous_return',
                'baseline-header': scenario.type === 'baseline',
                'scenario-type-header': scenario.type === 'scenario'
              }"
              (deleteScenario)="onDeleteScenario($event)"
              (applyStrategies)="openApplyStrategies($event)"
              (clearStrategies)="clearAppliedStrategies($event)">
          </th>

          <th class="add-scenario-cell">
            <button class="add-scenario-btn" (click)="onAddScenario()" title="Add Scenario">
              <i class="material-icons">add</i>
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let section of sections">
          <!-- Section header row -->
          <tr *ngIf="isSectionVisible(section)"
              class="section-row"
              [ngClass]="{'super-section-row': section.type === 'super', 'sub-section-row': section.type === 'sub'}">
            <td class="section-label-cell sticky-col"
                [ngClass]="{'super-section': section.type === 'super', 'sub-section': section.type === 'sub'}"
                (click)="toggleSection(section.key)">
              <i class="material-icons section-toggle">
                {{collapsedSections[section.key] ? 'chevron_right' : 'expand_more'}}
              </i>
              <span class="section-label">{{section.label}}</span>
            </td>
            <td *ngFor="let scenario of scenarios" class="section-spacer-cell"></td>
            <td class="section-spacer-cell"></td>
          </tr>

          <!-- Field rows -->
          <ng-container *ngFor="let field of getFieldsForSection(section.key)">
            <tr *ngIf="isFieldVisible(field)"
                class="field-row"
                [ngClass]="{'subtotal-row': field.isSubtotal}">
              <td class="field-label-cell sticky-col"
                  [ngClass]="{'subtotal-label': field.isSubtotal}">
                <span class="field-label" [title]="field.irsLine ? 'IRS Line ' + field.irsLine : ''">
                  {{field.label}}
                </span>
              </td>

              <td *ngFor="let scenario of scenarios"
                  appProjectionFieldCell
                  [field]="field"
                  [scenarioType]="scenario.type"
                  [value]="getFieldValue(scenario.id, field.key)"
                  [dropdownValue]="getDropdownValue(scenario.id, field.key)"
                  class="field-value-cell"
                  [ngClass]="{'subtotal-cell': field.isSubtotal, 'editable-cell': scenario.type === 'scenario' && !field.isSubtotal}"
                  (valueChange)="onFieldValueChange(scenario.id, $event.fieldKey, $event.value)">
              </td>

              <td class="field-end-cell"></td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>

  <!-- Apply Strategies Dialog -->
  <p-dialog header="Apply Plan Strategies"
            [(visible)]="showApplyStrategiesModal"
            [style]="{width: '600px'}"
            [modal]="true"
            [closable]="true">

    <div class="strategy-modal-step">
      <!-- Plan name display -->
      <div *ngIf="activePlanName" class="strategy-plan-name">
        Plan: <strong>{{activePlanName}}</strong>
      </div>

      <div *ngIf="loadingStrategies" class="strategy-loading">
        <div class="tpiq-loading-wheel" style="position: initial !important; height: 15vh !important;">
          <div align="center" class="fond">
            <div class="contener_general">
              <div class="contener_mixte"><div class="ballcolor ball_4">&nbsp;</div></div>
              <div class="contener_mixte"><div class="ballcolor ball_3">&nbsp;</div></div>
              <div class="contener_mixte"><div class="ballcolor ball_2">&nbsp;</div></div>
              <div class="contener_mixte"><div class="ballcolor ball_1">&nbsp;</div></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!loadingStrategies && clientPlans.length === 0" class="strategy-modal-empty">
        No plans found for this client. Create a plan first.
      </div>

      <div *ngIf="!loadingStrategies && clientPlans.length > 0 && strategyLines.length === 0" class="strategy-modal-empty">
        No strategies found for this plan.
      </div>

      <div *ngIf="!loadingStrategies && strategyLines.length > 0">
        <!-- Search bar -->
        <div class="strategy-search">
          <i class="material-icons strategy-search-icon">search</i>
          <input type="text"
                 [(ngModel)]="strategySearchTerm"
                 placeholder="Search strategies..."
                 class="strategy-search-input">
        </div>

        <!-- Select All header -->
        <div class="strategy-select-all">
          <label class="strategy-checkbox-label">
            <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
            <span>Select All ({{selectedLineIds.size}} of {{strategyLines.length}})</span>
          </label>
          <span class="strategy-savings-badge">
            Est. Savings: {{formatModalCurrency(getSelectedSavingsTotal())}}
          </span>
        </div>

        <!-- Strategy list -->
        <div class="strategy-list">
          <div *ngFor="let line of filteredStrategyLines"
               class="strategy-line-item"
               [ngClass]="{'ai-recommended': line.aiRecommended, 'in-plan': line.inPlan, 'not-in-plan': !line.inPlan}">
            <label class="strategy-checkbox-label">
              <input type="checkbox"
                     [checked]="isLineSelected(line.id)"
                     (change)="toggleStrategyLine(line.id)">
              <div class="strategy-line-info">
                <div class="strategy-line-name">
                  {{line.strategyName}}
                  <span *ngIf="line.aiRecommended" class="ai-badge">AI Recommended</span>
                  <span *ngIf="line.inPlan" class="plan-badge">In Plan</span>
                </div>
                <div *ngIf="line.inPlan" class="strategy-line-details">
                  <span class="strategy-amount">Amount: {{formatModalCurrency(line.amount)}}</span>
                  <span class="strategy-line-savings">Savings: {{formatModalCurrency(line.totalSavings)}}</span>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="strategy-modal-footer">
        <button class="button small secondary" (click)="closeApplyStrategiesModal()">Cancel</button>
        <button class="button small"
                [disabled]="selectedLineIds.size === 0 || applyingStrategies"
                (click)="applySelectedStrategies()">
          {{applyingStrategies ? 'Applying...' : 'Apply ' + selectedLineIds.size + ' Strategies'}}
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>
